var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circular",class:_vm.classCustom,style:(_vm.getDisplay)},[_c('span',{staticClass:"span"},[_vm._v(_vm._s(_vm.number))])])}
var staticRenderFns = []

export { render, staticRenderFns }